import Constants from '@freebe/sdk/constants'

export const entrepreneurs = {
  declaration: [{
      label: 'Mensuelle',
      value: Constants.entrepreneurs.declaration.monthly
    }, {
      label: 'Trimestrielle',
      value: Constants.entrepreneurs.declaration.quarterly
    }],
}

export default function useConstantsWording () {
  return {
    entrepreneurs,
  }
}